import { useEffect } from "react"
import { create } from "zustand"
import { loadTemplateCategories } from "~/common/videoTemplate/categories"

type CategoryStore = {
  categories: string[]
  status: "idle" | "loading" | "ready" | "error"
  error: string
  load: (refresh?: boolean) => Promise<void>
}

let pending: Promise<void> | null = null

export const useTemplateCategoriesStore = create<CategoryStore>((set, get) => ({
  categories: [],
  status: "idle",
  error: "",
  load: (refresh = false) => {
    if (pending) return pending
    if (!refresh && get().status === "ready") return Promise.resolve()
    set({ status: "loading", error: "" })
    pending = loadTemplateCategories()
      .then((categories) => set({ categories, status: "ready" }))
      .catch((error) => {
        set({
          categories: [],
          status: "error",
          error: error instanceof Error ? error.message : "模板分类加载失败",
        })
      })
      .finally(() => {
        pending = null
      })
    return pending
  },
}))

export const useTemplateCategories = () => {
  const categories = useTemplateCategoriesStore((state) => state.categories)
  const status = useTemplateCategoriesStore((state) => state.status)
  const error = useTemplateCategoriesStore((state) => state.error)
  const load = useTemplateCategoriesStore((state) => state.load)
  useEffect(() => {
    void load()
  }, [load])
  return { categories, status, error, reload: () => load(true) }
}
